
export class Selectable{
    constructor(){
        this.selectable = true;
    }
}